import {
  Component,
  OnInit,
  Input,
  OnDestroy,
  HostListener,
} from '@angular/core';
import { SubmitButtonShared } from 'src/app/presentation/general/shared/submit-button-shared';
import { Subscription } from 'rxjs';
import { TextHelper } from 'src/app/utils/text-helper';
import * as moment from 'jalali-moment';
import { RegisterShared } from 'src/app/presentation/general/shared/register-shared';
import { GenerateShared } from 'src/app/presentation/general/shared/generate-shared';
import { CookingStoryKitchenDataService } from 'src/app/data/repository/cooking-story/cooking-story-kitchen-data.service';

@Component({
  selector: 'app-date',
  templateUrl: './date.component.html',
  styleUrls: ['./date.component.scss'],
})
export class DateComponent implements OnDestroy, OnInit {
  @Input() isDetail = false;
  @Input() pageNumber: number;
  @Input() currentPageNumber: number;
  @Input() type: string;
  @Input() Redesign: boolean = false;
  @Input() expire: boolean = false;
  years: string[] = [];
  months: string[] = [
    'فروردین',
    'اردیبهشت',
    'خرداد',
    'تیر',
    'مرداد',
    'شهریور',
    'مهر',
    'آبان',
    'آذر',
    'دی',
    'بهمن',
    'اسفند',
  ];
  days: number[] = [];
  defaultDate: [string, number, number] = ['1370', 1, 21];
  selectedDate = [];
  dayOfset: number;
  yearOfset: number;
  monthOfset: number;
  subscription: Subscription;
  title: string;
  date: string[];
  constructor(
    private submitButtonShared: SubmitButtonShared,
    private textHelper: TextHelper,
    private registerShared: RegisterShared,
    private generateShared: GenerateShared,
    private CookingStoryKitchenDataService: CookingStoryKitchenDataService
  ) {
    this.setDefaultDate();
    this.submitButtonShared.activateNextButton(true);
    this.registerShared.registerActivateButton(2);
    this.subscription = this.submitButtonShared.nextButtonClickObs$.subscribe(
      (clicked) => {
        if (clicked && this.pageNumber === this.currentPageNumber) {
          const date = this.translateDataToDate();
          switch (this.type) {
            case 'birthdate': {
              this.registerShared.birthdate = date;
              this.registerShared.nextPage();
              break;
            }
            case 'breastfeeding':
            case 'pregnancy': {
              this.generateShared.specialTypeStartDate = date;
              if (this.isDetail) {
                this.generateShared.closeOverviewDetailAndChangeDifficulty();
              } else {
                this.generateShared.nextPage();
              }
              break;
            }
          }
          // console.log('bday', this.registerShared.birthdate)
        }
      }
    );
    this.CookingStoryKitchenDataService.submitDate.subscribe((clicked) => {
      if (clicked) {
        const date = this.translateDataToDate();
        this.registerShared.expireDate = date;
        this.CookingStoryKitchenDataService.datechanged(date);
      }
    });
  }
  ngOnInit() {
    switch (this.type) {
      case 'birthdate': {
        this.title = 'تاریخ تولد خود را مشخص کنید';
        break;
      }
      case 'breastfeeding':
      case 'pregnancy': {
        if (this.type == 'pregnancy') {
          this.title = 'تاریخ شروع دوره بارداری خود را مشخص کنید';
        } else {
          this.title = 'تاریخ شروع دوره شیردهی خود را مشخص کنید';
        }
        if (this.isDetail && this.generateShared.specialTypeStartDate) {
          const date = this.generateShared.specialTypeStartDate;
          this.defaultDate = [
            moment(date).format('jYYYY'),
            parseInt(moment(date).format('jMM')) - 1,
            parseInt(moment(date).format('jDD')) - 1,
          ];
          this.setDefaultDate();
        }
        break;
      }
      case 'expire': {
        this.defaultDate = [
          moment(Date.now()).format('jYYYY'),
          parseInt(moment(Date.now()).format('jMM')) - 1,
          parseInt(moment(Date.now()).format('jDD')) - 1,
        ];
        console.log(this.defaultDate);

        this.setDefaultDate();
      }
    }
  }
  selectItems(itemIndex: number, itemId: string) {
    const offset = (itemIndex - 2) * -40;

    if (itemId == 'days') {
      this.dayOfset = offset;
      document.getElementById('days').style.top = this.dayOfset + 'px';
    } else if (itemId == 'months') {
      this.monthOfset = offset;
      document.getElementById('months').style.top = this.monthOfset + 'px';
    } else if (itemId == 'years') {
      this.yearOfset = offset;
      document.getElementById('years').style.top = this.yearOfset + 'px';
    }
  }
  swipe(swipe: string, item: string, event) {
    if (swipe == 'swipeup') {
      this.nextSlide(item, event.velocity);
    } else if (swipe == 'swipedown') {
      this.perviousSlide(item, event.velocity);
    }
  }
  setDefaultDate() {
    let length = this.expire ? 5 : 90;
    this.years = Array.from({ length }, (v, i) => {
      const m = moment();
      if (this.expire) {
        return (m.jYear() + i).toString();
      } else {
        return (m.jYear() - i).toString();
      }
    });
    const DYear = this.years.findIndex((year) => this.defaultDate[0] == year);
    this.days = Array.from(
      {
        length: moment.jDaysInMonth(
          parseInt(this.defaultDate[0]),
          this.defaultDate[1]
        ),
      },
      (v, i) => {
        return i + 1;
      }
    );
    this.selectedDate = [DYear, this.defaultDate[1], this.defaultDate[2]];

    setTimeout(() => {
      this.selectItems(DYear, 'years');
      this.selectItems(this.defaultDate[1], 'months');
      this.selectItems(this.defaultDate[2], 'days');
    }, 100);
  }
  nextSlide(item: string, velocity: number) {
    velocity = Math.ceil((velocity < 0 ? -1 * velocity : velocity) * 2);
    if (item == 'days') {
      if (
        this.selectedDate[2] >= 0 &&
        this.selectedDate[2] <= this.days.length
      ) {
        if (this.selectedDate[2] + velocity >= this.days.length) {
          this.selectedDate[2] = this.days.length - 1;
          this.selectItems(this.selectedDate[2], 'days');
        } else {
          this.selectedDate[2] = this.selectedDate[2] + velocity;
          this.selectItems(this.selectedDate[2], 'days');
        }
      }
    } else if (item == 'months') {
      if (
        this.selectedDate[1] >= 0 &&
        this.selectedDate[1] <= this.months.length
      ) {
        if (this.selectedDate[1] + velocity >= this.months.length) {
          this.selectedDate[1] = this.months.length - 1;
          this.selectItems(this.selectedDate[1], 'months');
        } else {
          this.selectedDate[1] = this.selectedDate[1] + velocity;
          this.selectItems(this.selectedDate[1], 'months');
        }
        const l = this.checkKabiseDay();
        this.days = Array.from(
          {
            length: l,
          },
          (v, i) => {
            return i + 1;
          }
        );
        if (this.days.length <= this.selectedDate[2] + 1) {
          this.selectedDate[2] = this.days.length - 1;
          this.selectItems(this.days.length - 1, 'days');
        }
      }
    } else if (item == 'years') {
      if (
        this.selectedDate[0] >= 0 &&
        this.selectedDate[0] <= this.years.length
      ) {
        if (this.selectedDate[0] + velocity >= this.years.length) {
          this.selectedDate[0] = this.years.length - 1;
          this.selectItems(this.selectedDate[0], 'years');
        } else {
          this.selectedDate[0] = this.selectedDate[0] + velocity;
          this.selectItems(this.selectedDate[0], 'years');
        }
      }
      const l = this.checkKabiseDay();
      this.days = Array.from(
        {
          length: l,
        },
        (v, i) => {
          return i + 1;
        }
      );
      if (this.days.length <= this.selectedDate[2] + 1) {
        this.selectedDate[2] = this.days.length - 1;

        this.selectItems(this.days.length - 1, 'days');
      }
    }
  }
  perviousSlide(item: string, velocity: number) {
    velocity = Math.ceil((velocity < 0 ? -1 * velocity : velocity) * 2);
    if (item == 'days') {
      if (
        this.selectedDate[2] > 0 &&
        this.selectedDate[2] <= this.days.length
      ) {
        if (this.selectedDate[2] - velocity <= 0) {
          this.selectedDate[2] = 0;
          this.selectItems(this.selectedDate[2], 'days');
        } else {
          this.selectedDate[2] = this.selectedDate[2] - velocity;
          this.selectItems(this.selectedDate[2], 'days');
        }
      }
    } else if (item == 'months') {
      if (
        this.selectedDate[1] > 0 &&
        this.selectedDate[1] <= this.months.length
      ) {
        if (this.selectedDate[1] - velocity <= 0) {
          this.selectedDate[1] = 0;
          this.selectItems(this.selectedDate[1], 'months');
        } else {
          this.selectedDate[1] = this.selectedDate[1] - velocity;
          this.selectItems(this.selectedDate[1], 'months');
        }
        const l = this.checkKabiseDay();
        this.days = Array.from(
          {
            length: l,
          },
          (v, i) => {
            return i + 1;
          }
        );

        if (this.days.length <= this.selectedDate[2] + 1) {
          this.selectedDate[2] = this.days.length - 1;

          this.selectItems(this.days.length - 1, 'days');
        }
      }
    } else if (item == 'years') {
      if (
        this.selectedDate[0] > 0 &&
        this.selectedDate[0] <= this.years.length
      ) {
        if (this.selectedDate[0] - velocity <= 0) {
          this.selectedDate[0] = 0;
          this.selectItems(this.selectedDate[0], 'years');
        } else {
          this.selectedDate[0] = this.selectedDate[0] - velocity;
          this.selectItems(this.selectedDate[0], 'years');
        }
      }
      const l = this.checkKabiseDay();
      this.days = Array.from(
        {
          length: l,
        },
        (v, i) => {
          return i + 1;
        }
      );
      if (this.days.length <= this.selectedDate[2] + 1) {
        this.selectedDate[2] = this.days.length - 1;

        this.selectItems(this.days.length - 1, 'days');
      }
    }
  }
  @HostListener('window:beforeunload')
  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
  translateDataToDate() {
    const y = this.years[this.selectedDate[0]];
    const m = this.selectedDate[1] + 1;
    const faDateString = y + '/' + m + '/' + parseInt(this.selectedDate[2] + 1);
    console.log(faDateString);

    const d = moment.from(faDateString, 'fa', 'YYYY/MM/DD').locale('en');

    const day = d.format('DD');
    const month = parseInt(d.format('MM')) - 1;
    const year = d.format('YYYY');

    return new Date(parseInt(year), month, parseInt(day));
  }
  checkKabiseDay() {
    const y = this.years[this.selectedDate[0]];
    const m = this.selectedDate[1] + 1;
    let d = moment.jDaysInMonth(
      parseInt(this.selectedDate[0]),
      this.selectedDate[1]
    );

    const faDateString = y + '/' + m + '/' + d;

    const date = moment.from(faDateString, 'fa', 'YYYY/MM/DD').locale('en');
    if (!date.isValid()) {
      return d - 1;
    } else {
      return d;
    }
  }
}
